






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseActivity from '@/components/administration/activity/edit/EditBaseActivity.vue'
import EditBaseSeo from '@/components/shared/EditBaseSeo.vue'
import { getDefaultAloActivity } from '@/models/alo/AloActivity'
import { AloActivity } from '@/models/alo/AloActivity'

@Component({ 
  name: 'EditSeo',     
  components:{EditBaseActivity,EditBaseSeo}
})
export default class EditSeo extends Vue {
      
  private activity:AloActivity = getDefaultAloActivity()

  edit(item:AloActivity) {            
    this.activity = (this.$refs.baseEdit as EditBaseActivity).edit(item)    
  }        
}
